import React from 'react'
import './styles.scss'

import COLORS from '../../styles/colors'

import Loader from '../Loader'
import XSvg from '../../assets/svgs/X'

import Button from '../../components/Button'

interface IPropType {
  className?: string
  status?: string
  insurer?: string
  timedOut?: boolean
  onClickTimeout: () => void
  tenantsAddAction: () => void
}

export default function InsuranceEvalComponent({
  onClickTimeout,
  timedOut,
  className = '',
  status = '',
  insurer,
  tenantsAddAction,
}: IPropType) {
  const insuranceData = (() => {
    switch (status) {
      case 'APPROVED':
        return {
          upperContent: insurer,
          lowerContent: 'Sua requisição para Seguro Fiança foi aprovada, agora é só criar o contrato!',
          styles: {
            container: {},
            text: {},
          },
        }
      case 'REFUSED':
        return {
          upperContent: <XSvg style={{ marginTop: 15 }} />,
          lowerContent:
            'Sua requisição para Seguro Fiança ' +
            'foi recusada! Por favor selecione ' +
            'outra modalidade de Garantia ou ' +
            'entre em contato conosco!',
          styles: {
            container: {
              borderColor: COLORS.uiSpecific.danger,
            },
            text: {
              color: COLORS.uiSpecific.danger,
              fontSize: '1.2em',
            },
          },
        }
      case 'LOADING':
      default:
        return {
          upperContent: <Loader />,
          lowerContent:
            'Sua requisição para Seguro Fiança encontra-se em análise. Isso pode levar alguns minutos',
          styles: {
            container: {},
            text: {},
          },
        }
    }
  })()

  return (
    <div style={insuranceData.styles.container} className={`insurance-eval-container ${className}`}>
      <div className='upper-row'>{insuranceData.upperContent}</div>
      <div className='lower-row'>
        <p style={insuranceData.styles.text} className='info'>
          {insuranceData.lowerContent}
        </p>
        {timedOut ? (
          <div style={{ margin: '20px 0' }}>
            <p
              style={{
                color: COLORS.uiSpecific.danger,
                fontSize: '1.2em',
              }}
            >
              Você pode tentar checar o seguro novamente
            </p>
            <div className='retry-button-wrapper'>
              <Button title={'Checar novamente'} onClick={onClickTimeout} />
            </div>
          </div>
        ) : (
          status === 'REFUSED' && (
            <div className='add-tenants-wrapper'>
              <Button title={'Adicione um morador'} onClick={tenantsAddAction} />
            </div>
          )
        )}
      </div>
    </div>
  )
}
